module.exports = __webpack_public_path__ + "assets/0382449e727daef03fdacd5f869b9f2f.mp3";